import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Route, Routes } from "react-router-dom";
import ClientOrder from "./ClientOrder";
import Addproduct from "./Addproduct";
import InquiryFormData from "./InquiryFormData";
import ContactFormData from "./ContactFormData";
import AddBlog from "./AddBlog";
import BlogTable from "./BlogTable";
import ProductsTable from "./ProductsTable";
import LogoAdmin from "../../src/assets/Roimages/Logo.png";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faTag,
  faSignOutAlt,
  faCartShopping,
  faEnvelope,
  faFileAlt,
  faPlus,
  faTable,
} from "@fortawesome/free-solid-svg-icons";

const Admin = ({ setIsAuthenticated }) => {
  const [isToggled, setIsToggled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isFirstRender = useRef(true);

  const handleToggle = () => {
    setIsToggled(!isToggled);
    document.body.classList.toggle("no-scroll", !isToggled);
  };

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsToggled(true);
    } else {
      setIsToggled(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isFirstRender.current && location.pathname === "/Admin") {
      navigate("/Admin/ProductsTable");
      isFirstRender.current = false;
    }
  }, [location, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    setIsAuthenticated(false);

    navigate("/LoginAdmin");
  };

  return (
    <div className="adminMain">
      <section className="dashboard-area">
        <div className="container-fluid py-1 pt-2">
          <div className="row">
            <div
              className={`sidebar_row px-md-2 px-sm-1 px-1 ${isToggled ? "d-block" : "d-none"
                }`}
            >
              <div className="left-sidebar-wrapper box-style-admin sticky">
                <div className="sidebar-header py-2 px-1">
                  <div className="info text-center">
                    <img
                      src={LogoAdmin}
                      alt="imgLogo"
                      className="img-fluid col-lg-7 col-md-10 col-sm-12 col-12 py-2"
                    />
                  </div>
                </div>
                <div className="sidebar-menu text-start">
                  <nav>
                    <ul className="p-0">
                      <li>
                        <NavLink
                          to="/Admin/ProductsTable"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon
                            className="adminicon"
                            icon={faGauge}
                          />
                          Dashboard
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Admin/Addproduct"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon className="adminicon" icon={faTag} />
                          Add Product
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Admin/AddBlog"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon className="adminicon" icon={faPlus} />
                          Add Blog
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Admin/BlogTable"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon className="adminicon" icon={faTable} />
                          Blog Table
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Admin/ClientOrder"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon
                            className="adminicon"
                            icon={faCartShopping}
                          />
                          Orders
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Admin/InquiryFormData"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon
                            className="adminicon"
                            icon={faFileAlt}
                          />
                          User Inquiry
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Admin/ContactFormData"
                          className={({ isActive }) =>
                            isActive ? "active" : "navlink"
                          }
                        >
                          <FontAwesomeIcon
                            className="adminicon"
                            icon={faEnvelope}
                          />
                          Contact Data
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="Admin" onClick={handleLogout}>
                          <FontAwesomeIcon
                            className="adminicon"
                            icon={faSignOutAlt}
                          />
                          Sign Out
                        </NavLink>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <div
              className="sidebar_table px-1"
              style={{ width: isToggled ? "calc(80%)" : "100%" }}
            >
              <button
                className="btn tglbtn1 ms-0 mb-2 p-0"
                id="sidebarToggle"
                onClick={handleToggle}
              >
                <i
                  className={`sidebaricon fs-3 fw-bold bi ${isToggled ? "bi-x" : "bi-list"
                    }`}
                />
              </button>

              <div className="right-content-wrapper box-style">
                <Routes>
                  <Route path="ProductsTable" element={<ProductsTable />} />
                  <Route path="Addproduct" element={<Addproduct />} />
                  <Route path="AddBlog" element={<AddBlog />} />
                  <Route path="BlogTable" element={<BlogTable />} />
                  <Route path="ClientOrder" element={<ClientOrder />} />
                  <Route path="InquiryFormData" element={<InquiryFormData />} />
                  <Route path="ContactFormData" element={<ContactFormData />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Admin;
